import { Input } from "@kalyzee/kast-web-sdk/web-components";
import clsx from "clsx";
import { useCallback, useState } from "react";
import { PageMasterMode, usePageContextRef } from "../../../../components/navigation/PageContext";
import { SessionMode } from "../../../../contexts/appStore/hooks";
import { getGlobalQueryLabel, NavigateGlobalQuery } from "../../../../helpers/navigation";
import { parseMeetingReference } from "../../../../helpers/meetingReference";
import authStyles from "../../../public/login/auth.module.css";
import styles from "./JoinMeetingView.module.css";

/**
 * Safety net shown on /list when `ui.disableMeetingList` is active (LMS
 * integrations): no agendas — just a field to reach a meeting lobby from a
 * pasted link or id. The normal entry point remains the LMS deep link.
 */
export const JoinMeetingView = () => {
  const pageContextRef = usePageContextRef<SessionMode.MASTER>();
  const [value, setValue] = useState("");
  const [error, setError] = useState(false);

  const onChange = useCallback((next: string) => {
    setValue(next);
    setError(false);
  }, []);

  const onSubmit = useCallback((event: React.FormEvent) => {
    event.preventDefault();
    const reference = parseMeetingReference(value);
    if (!reference) {
      setError(true);
      return;
    }
    pageContextRef.current?.goTo(
      PageMasterMode.LOBBY,
      { id: reference.id },
      reference.provider
        ? { queries: { [getGlobalQueryLabel(NavigateGlobalQuery.PROVIDER)]: reference.provider } }
        : undefined,
    );
  }, [value, pageContextRef]);

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Rejoindre un meeting</h1>
      <p className={styles.subtitle}>
        Collez le lien du meeting ou saisissez son identifiant.
      </p>
      <form className={styles.form} onSubmit={onSubmit}>
        <Input
          className={authStyles.glassInput}
          value={value}
          setValue={onChange}
          nativeProps={{ placeholder: "Lien ou identifiant du meeting" }}
        />
        <button
          type="submit"
          className={clsx(authStyles.button, authStyles.buttonGreen)}
          disabled={!value.trim()}
        >
          Rejoindre
        </button>
      </form>
      {error && <p className={styles.error}>Lien ou identifiant non reconnu.</p>}
    </div>
  );
};
